import { Box } from "@mui/material";
import { NEUTRAL, STATUS } from "../../theme/tokens";

interface SegmentedProgressBarProps {
	value: number;
	total: number;
	width: number;
	height: number;
}

export const SegmentedProgressBar = ({ value, total, width, height }: SegmentedProgressBarProps) => {
	const segments = 8;
	const filledSegments = Math.round((value / total) * segments);
	const gapSize = 3;
	const totalGapsWidth = gapSize * (segments - 1);
	const segmentWidth = (width - totalGapsWidth) / segments; // Calculate segment width accounting for gaps

	const getColor = (occupancyRate: number) => {
		if (occupancyRate < 70) return STATUS.SUCCESS.main; // Green for low occupancy
		if (occupancyRate < 90) return STATUS.WARNING.main; // Orange for medium occupancy
		return STATUS.ERROR.main; // Red for high occupancy
	};

	const color = getColor((value / total) * 100);

	return (
		<Box
			sx={{
				display: "flex",
				gap: `${gapSize}px`,
				width: `${width}px`,
				height: `${height}px`,
				alignItems: "center",
			}}
		>
			{Array.from({ length: segments }).map((_, index) => (
				<Box
					key={index}
					sx={{
						width: `${segmentWidth}px`,
						height: "60%", // Make segments shorter
						backgroundColor: index < filledSegments ? color : NEUTRAL[300],
						borderRadius: "3px", // Slightly increased border radius
						transition: "background-color 0.2s ease", // Smooth color transition
					}}
				/>
			))}
		</Box>
	);
};
